
<section 
  #routeTimelineRef
  class="custom-route__route-timeline"
>
  <app-timeline />
  
  <app-points />

  <!--<app-action-buttons />-->
</section>